"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADER_VALUE_X_CLIENT_APPLICATION = exports.HEADER_KEY_X_CLIENT_APPLICATION = void 0;
const HEADER_VALUE_X_CLIENT_APPLICATION = exports.HEADER_VALUE_X_CLIENT_APPLICATION = 'Web';
const HEADER_KEY_X_CLIENT_APPLICATION = exports.HEADER_KEY_X_CLIENT_APPLICATION = 'x-client-application';
